import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import NavBar from "./components/custom/NavBar";
import HeroSection from "./components/custom/HeroSection";
import Footer from "./components/custom/Footer";
import AgencyPage from "./pages/AgencyPage";
import ApplyPage from "./pages/ApplyPage";
import LibraryPage from "./pages/LibraryPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPage from "./pages/PrivacyPage";
import LegalPage from "./pages/LegalPage";

const HomePage = () => {
  return (
    <div data-testid="home-page" style={{ backgroundColor: '#050A14', minHeight: '100dvh' }}>
      <HeroSection />
    </div>
  );
};

// Layout wrapper for pages with footer
const PageLayout = ({ children }) => {
  return (
    <div className="flex flex-col" style={{ backgroundColor: '#050A14', minHeight: '100dvh' }}>
      <div className="flex-grow">
        {children}
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<><NavBar /><HomePage /></>} />
            <Route path="/agence" element={<><NavBar /><PageLayout><AgencyPage /></PageLayout></>} />
            <Route path="/postuler" element={<><NavBar /><ApplyPage /></>} />
            <Route path="/bibliotheque" element={<><NavBar /><PageLayout><LibraryPage /></PageLayout></>} />
            <Route path="/confidentialite" element={<><NavBar /><PageLayout><PrivacyPage /></PageLayout></>} />
            <Route path="/mentions-legales" element={<><NavBar /><PageLayout><LegalPage /></PageLayout></>} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
